import React, { useEffect, useState } from 'react'
import './index.scss'

const InputNumberBar = (props) => {
  const { value, step, onChange, inputDisabled, max, min, prefix, formatFn } = props
  const [inputVal, setInputVal] = useState('')
  const [subBtnDisabled, setSubBtnDisabled] = useState(false)
  const [plusBtnDisabled, setPlusBtnDisabled] = useState(false)

  useEffect(() => {
    setInputVal(calInputVal(value))
  }, [value])

  useEffect(() => {
    isNumberExceed(value)
  }, [value, max, min])


  function calInputVal(val) {
    return typeof formatFn === 'function' ? `${prefix}${formatFn(val)}` : `${prefix}${(val)}`
  }

  const handleChange = (val) => {
    if (isNumberExceed(val)) return
    setInputVal(calInputVal(val))
    typeof onChange === 'function' && onChange(val)
  }

  function subNumber() {
    let newVal = value - step
    handleChange(newVal)
  }

  function plusNumber() {
    let newVal = value + step
    handleChange(newVal)
  }


  function isNumberExceed(val) {
    setSubBtnDisabled(val <= min)
    setPlusBtnDisabled(val >= max)
    return val > max || val < min
  }


  return (
    <div className='input-number-bar'>
      <input
        type='text'
        disabled={inputDisabled}
        value={inputVal}
        onChange={(e) => handleChange(e.target.value)}
      />
      <button className='sub-btn' disabled={subBtnDisabled} onClick={subNumber}>
        <i className='iconfont iconGroup-' />
      </button>
      <button className='plus-btn' disabled={plusBtnDisabled} onClick={plusNumber}>
        <i className='iconfont icona-Group' />
      </button>
        
    </div>
  )
}

export default InputNumberBar
